import { useEffect, useState } from "react";
import { UserRound, Lock } from "lucide-react";
import { api } from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";

export const roleLabel = (r, labels) => ({ admin: "Admin", tabteam: "Tab Team", distributor: "Distribütör", newcomer: "Yeni Katılımcı", ...(labels || {}) }[r] || "Distribütör");

const collator = new Intl.Collator("tr", { sensitivity: "base" });

export function groupByCategory(items, nameKey = "name") {
  const groups = {};
  items.forEach((it) => {
    const cat = (it.category || "Genel").trim() || "Genel";
    (groups[cat] = groups[cat] || []).push(it);
  });
  return Object.keys(groups)
    .sort(collator.compare)
    .map((cat) => ({ category: cat, items: groups[cat].sort((a, b) => collator.compare(a[nameKey] || "", b[nameKey] || "")) }));
}

export function OwnerBadge({ ownerId }) {
  const { user } = useAuth();
  const [names, setNames] = useState(null);
  useEffect(() => {
    if (user?.role !== "admin") return;
    if (!cache) cache = api.get("/users/names").then((r) => r.data).catch(() => ({}));
    cache.then(setNames);
  }, [user]);
  if (user?.role !== "admin" || !ownerId || !names) return null;
  const mine = ownerId === user.id;
  return (
    <span data-testid="owner-badge" className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-semibold ${mine ? "bg-secondary text-muted-foreground" : "bg-amber-500/15 text-amber-500"}`}>
      <UserRound className="h-3 w-3" /> {mine ? "Siz" : names[ownerId] || "Kullanıcı"}
    </span>
  );
}
let cache = null;

export function LockBadge({ item }) {
  const { user } = useAuth();
  if (!item?.locked || user?.role === "admin") return null;
  return (
    <span data-testid="lock-badge" title="Yönetici kataloğu — değiştirilemez" className="inline-flex items-center gap-1 rounded-full bg-secondary px-2 py-0.5 text-[10px] font-semibold text-muted-foreground">
      <Lock className="h-3 w-3" /> Katalog
    </span>
  );
}

export const useCanEdit = () => {
  const { user } = useAuth();
  return (item) => user?.role === "admin" || !item?.locked;
};

export const CategoryHeader = ({ title, count, suffix, extra }) => (
  <div className="col-span-full mt-2 flex items-center gap-3 first:mt-0" data-testid={`category-header-${title}`}>
    <h3 className="font-heading text-sm font-extrabold uppercase tracking-[0.2em] text-primary">{title}</h3>
    <span className="rounded-full bg-secondary px-2 py-0.5 text-[11px] text-muted-foreground">{count} {suffix}</span>
    {extra}
    <div className="h-px flex-1 bg-border" />
  </div>
);
